import { createSlice, isRejectedWithValue } from '@reduxjs/toolkit'

const initialState = { errorMsg: null, errorType: null }

export const apiErrorSlice = createSlice({
  name: "apiError",
  initialState,
  reducers: {
      setErrorMessage(state, errorMsg) {
        return {...state, "errorMsg": errorMsg.payload};
      },
      setErrorType(state, errorType) {
        return {...state, "errorType": errorType.payload};
      },
      clearError(state) {
        return {...state, "errorMsg": null, "errorType": null};
      },
  },
})

/**
 * MIDDLEWARE
 * Log a warning & set the error info in Store so the ErrorModal can pick up the error and display it
 */
export const rtkQueryErrorLogger = (api) => (next) => (action) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  if (isRejectedWithValue(action)) {
    console.warn('We got a rejected API call!')
    api.dispatch(apiErrorSlice.actions.setErrorMessage(action.error.message));

    if (action?.payload?.status === 403) {
      window.location = '/unauthorized'
      // api.dispatch(apiErrorSlice.actions.setErrorType("Forbidden"))
    } else {
      api.dispatch(apiErrorSlice.actions.setErrorType("ServerError"));
    }
     //TODO: How do we know what is an internal server error and what is a lack of connection??
  }

  return next(action)
}
